module.exports = __webpack_public_path__ + "static/media/boomapp_thumb.ae59fda5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/boomapp_thumb.png
// module id = 177
// module chunks = 0